export const STANDUP_CLIPS = [
  { title: "R.T. — Straws", performer: "R.T.", youtubeId: "LRaGnp4v_NM" },
  { title: "Leslie Jones — Live on the Mic", performer: "Leslie Jones", youtubeId: "jYdC-bzSClk" },
  { title: "Esau McGraw — Live", performer: "Esau McGraw", youtubeId: "6x7MGqgV4xs" },
];

export const LOGO = "/assets/brand/logo.png";
export const KEY_ART = "/assets/brand/key-art.jpg";
export const STANDUP_POSTER = "/assets/brand/standup-poster.jpg";

export const SOCIAL = {
  tiktok: "https://www.tiktok.com/@laughatla",
  instagram: "https://www.instagram.com/laughatla/",
  x: "https://x.com/Laughatla",
  youtube: "https://www.youtube.com/@laughatlacomedy",
  imdb: "https://www.imdb.com/title/tt9341524/",
  emailShow: "laughatla@gmail.com",
  emailPfg: "info@providencefilmgroup.org",
};

export const HOST = {
  name: "Todd Bridges",
  role: "Host",
  img: "/assets/cast/todd-bridges.jpg",
  imdb: "https://www.imdb.com/name/nm0004775/",
  credit: "Different Strokes, Everybody Hates Chris",
};

export const CAST = [
  { name: "Leslie Jones", role: "Featured Talent", img: "/assets/cast/leslie-jones.jpg", imdb: "https://www.imdb.com/name/nm0428656/" },
  { name: "Kel Mitchell", role: "Featured Talent", img: "/assets/cast/kel-mitchell.jpg", imdb: "https://www.imdb.com/name/nm0005239/" },
  { name: "Debra Wilson", role: "Featured Talent", img: "/assets/cast/debra-wilson.jpg", imdb: "https://www.imdb.com/name/nm0933281/" },
  { name: "Sandy Brown", role: "Featured Talent", img: "/assets/cast/sandy-brown.jpg", imdb: "https://www.imdb.com/name/nm1192177/" },
  { name: "Bill Glass", role: "Featured Talent", img: "/assets/cast/bill-glass.jpg", imdb: "https://www.imdb.com/name/nm0321913/" },
  { name: "Esau McGraw", role: "Featured Talent", img: "/assets/cast/esau-mcgraw-headshot.jpg", imdb: "https://www.imdb.com/name/nm2313611/" },
  { name: "Charlie Talbert", role: "Sketch Cast", img: "/assets/cast/charlie-talbert.jpg", imdb: "https://www.imdb.com/name/nm0847857/" },
  { name: "Christopher Reid", role: "Sketch Cast", img: "/assets/cast/christopher-reid.jpg", imdb: "https://www.imdb.com/name/nm0717212/" },
  { name: "Daniel Toscano", role: "Sketch Cast", img: "/assets/cast/daniel-toscano.jpg", imdb: "https://www.imdb.com/name/nm0869118/" },
  { name: "Hugh Moore", role: "Sketch Cast", img: "/assets/cast/hugh-moore.jpg", imdb: "https://www.imdb.com/name/nm1263844/" },
  { name: "Jill-Michele Meleán", role: "Sketch Cast", img: "/assets/cast/jill-michele-melean.jpg", imdb: "https://www.imdb.com/name/nm0577549/" },
  { name: "Jina Song", role: "Sketch Cast", img: "/assets/cast/jina-song.jpg", imdb: "https://www.imdb.com/name/nm2261607/" },
  { name: "Kelly Stables", role: "Sketch Cast", img: "/assets/cast/kelly-stables.jpg", imdb: "https://www.imdb.com/name/nm1261587/" },
  { name: "Kira Soltanovich", role: "Sketch Cast", img: "/assets/cast/kira-soltonovich.jpg", imdb: "https://www.imdb.com/name/nm0813597/" },
  { name: "Nadya Ginsburg", role: "Sketch Cast", img: "/assets/cast/nadya-ginsburg.jpg", imdb: "https://www.imdb.com/name/nm0320146/" },
  { name: "Nino Alicea", role: "Sketch Cast", img: "/assets/cast/nino-alicea.jpg", imdb: "https://www.imdb.com/name/nm3059492/" },
  { name: "Rebecca Corry", role: "Sketch Cast", img: "/assets/cast/rebecca-corry.jpg", imdb: "https://www.imdb.com/name/nm1128600/" },
  { name: "Ron G.", role: "Sketch Cast", img: "/assets/cast/ron-g.jpg", imdb: "https://www.imdb.com/name/nm2956465/" },
  { name: "Sadiki Fuller", role: "Sketch Cast", img: "/assets/cast/sadiki-fuller.jpg", imdb: "https://www.imdb.com/name/nm1888342/" },
  { name: "Thea Vidale", role: "Sketch Cast", img: "/assets/cast/thea-vidale.jpg", imdb: "https://www.imdb.com/name/nm0896422/" },
  { name: "Todd Rexx", role: "Sketch Cast", img: "/assets/cast/todd-rexx.jpg", imdb: "https://www.imdb.com/name/nm0721005/", note: "Listed on IMDb as Todd Rex" },
];

// Profiles supplied by production but not yet matched to a confirmed IMDb page — shown without a link.
export const CAST_UNCONFIRMED = [
  { name: "Dwayne Perkins", role: "Performer", img: "/assets/cast/dwayne-perkins.jpg" },
  { name: "Jayne Warren", role: "Performer", img: "/assets/cast/jayne-warren.jpg" },
  { name: "Jenn Shagrin", role: "Performer", img: "/assets/cast/jenn-shagrin.jpg" },
  { name: "Juan Garcia", role: "Performer", img: "/assets/cast/juan-garcia.jpg" },
  { name: "R.T.", role: "Performer", img: "/assets/cast/r.t.jpg" },
  { name: "Rodney Mason", role: "Episode 2 Cast", img: "/assets/cast/rodney-mason.jpg" },
];

export const SKETCH_GROUPS = [
  {
    title: "Bathroom Attendant",
    tag: "Series",
    sketches: [
      {
        title: "Bathroom Attendant 1", episode: 2,
        credits: [
          { name: "Charlie Talbert", role: "Patron 1" },
          { name: "Rodney Mason", role: "Bathroom Attendant" },
          { name: "Bill Glass", role: "Patron 2" },
          { name: "Daniel Toscano", role: "Patron 3" },
        ],
        description: "A nightclub restroom attendant turns handwashing into a house rule and a breath mint into a luxury purchase. When a customer questions the price, the attendant sends him straight to “corporate.”",
      },
      {
        title: "Bathroom Attendant 2", episode: 9,
        credits: [
          { name: "Rodney Mason", role: "Bathroom Attendant" },
          { name: "Charlie Talbert", role: "Patron 1" },
          { name: "Daniel Toscano", role: "Patron 2" },
        ],
        description: "Three guys swagger into a nightclub restroom convinced they own the room. The attendant overhears their bragging and decides it's time to give them a lesson in dating.",
      },
    ],
  },
  {
    title: "Negotiating Actor",
    tag: "Series",
    sketches: [
      {
        title: "Negotiating Actor — Sean Connery", episode: 4,
        credits: [
          { name: "Debra Wilson", role: "Director" },
          { name: "Bill Glass", role: "Actor" },
          { name: "Jayne Warren", role: "Producer" },
          { name: "Daniel Toscano", role: "Sean Connery" },
        ],
        description: "In this Hollywood parody, a Sean Connery impersonation takes center stage as a director tries to shoot a revenge scene and her leading man keeps rewriting it mid-take.",
      },
      {
        title: "Negotiating Actor — 50 Cent", episode: 7,
        youtube: { id: "IKGBcdNppBU", label: "Full sketch" },
        youtube2: { id: "iYgAsU489hs", label: "Short clip" },
        credits: [
          { name: "Kel Mitchell", role: "50 Cent" },
          { name: "Nadya Ginsburg", role: "Director" },
          { name: "Bill Glass", role: "Manager" },
          { name: "Kelly Stables", role: "Actress" },
          { name: "Jenn Shagrin", role: "PA" },
          { name: "Charlie Talbert", role: "Villain" },
        ],
        description: "A director asks for tears in a death scene. The actor and his agent are happy to oblige, as soon as production agrees to pay extra for crying.",
      },
    ],
  },
];

export const SKETCHES = [
  {
    title: "Super Hero", episode: 1,
    credits: [
      { name: "Bill Glass", role: "Super Hero" },
      { name: "Jill-Michele Meleán", role: "Woman" },
      { name: "Charlie Talbert", role: "Thug 1" },
      { name: "Kelly Stables", role: "Girl in Danger" },
      { name: "Daniel Toscano", role: "Thug 2" },
      { name: "Jina Song", role: "Thug 3" },
    ],
    description: "A man slips away from a dinner date to rescue a woman from a gang of thugs. He has the confidence of a comic-book hero and a costume to match. Superpowers are another matter.",
  },
  {
    title: "Criminal Career Institute", episode: 3,
    youtube: { id: "HDiMp7xTuvk", label: "Watch the sketch" },
    credits: [
      { name: "Debra Wilson", role: "Student 1" },
      { name: "Bill Glass", role: "Bar Patron" },
      { name: "Nadya Ginsburg", role: "Teacher" },
      { name: "Rodney Mason", role: "Police Officer" },
      { name: "Jill-Michele Meleán", role: "Student 2" },
    ],
    description: "Stuck in a dead-end job? A spoof trade-school commercial offers a career change with degrees in burglary, embezzlement, and an elective you probably weren't expecting.",
  },
  {
    title: "Dr. Cop Lawyer", episode: 5,
    youtube: { id: "whHYb_SxqoI", label: "Watch the sketch" },
    credits: [
      { name: "Kirk Pynchon", role: "Written by" },
      { name: "Daniel Toscano", role: "Dr. Cop Lawyer" },
      { name: "Kel Mitchell", role: "Criminal" },
      { name: "Jina Song", role: "Parent" },
      { name: "Charlie Talbert", role: "Attorney" },
      { name: "Jayne Warren", role: "Nurse" },
      { name: "Nino Alicea", role: "Police Officer" },
    ],
    description: "One man wears scrubs, carries a badge, and argues cases in court. In this send-up of TV procedurals, a drug-house stakeout sends him scrambling between all three jobs.",
  },
  {
    title: "The Micromanager", episode: 6,
    youtube: { id: "KZ31faCS1LA", label: "Watch the sketch" },
    credits: [
      { name: "Charlie Talbert", role: "Micro Manager" },
      { name: "Bill Glass", role: "Employee 1" },
      { name: "Rodney Mason", role: "Employee 2 / Rapper" },
      { name: "Daniel Toscano", role: "Mike" },
      { name: "Jill-Michele Meleán", role: "Employee 3" },
      { name: "Kel Mitchell", role: "Tyrone" },
      { name: "Nadya Ginsburg", role: "Manager" },
      { name: "Jina Song", role: "Waitress" },
    ],
    description: "Mike comes in twelve minutes late and walks straight into his boss's cross-examination. In this office, the manager even has rules for how many times you can chew your lunch.",
  },
  {
    title: "What If?", episode: 8,
    youtube: { id: "V5aV9mf5gGM", label: "Insurance Sales" },
    youtube2: { id: "9PFKYaQB3G8", label: "The Traffic Stop" },
    credits: [
      { name: "Daniel Toscano", role: "Host" },
      { name: "Kel Mitchell", role: "Boss" },
      { name: "Debra Wilson", role: "Woman 1" },
      { name: "Bill Glass", role: "Driver" },
      { name: "Jill-Michele Meleán", role: "Woman 2" },
      { name: "Charlie Talbert", role: "Insurance Salesman" },
      { name: "Rodney Mason", role: "Police Officer" },
      { name: "Jayne Warren", role: "Woman 3" },
    ],
    description: "An over-the-top TV host flips racial stereotypes to see how they look from the other side. Everyday encounters, from crossing the street to interviewing for a job, become the setup for a social satire.",
  },
  { title: "Quick Money", description: "A man drowning in bills gets a surprise sales pitch on his front lawn. The spokesperson promises fast cash and has an alarmingly broad definition of collateral." },
  { title: "Shopping Network", description: "Home-shopping host Charmaine Phelps tries to make a sale from a set that looks ready to fall over. As she waits for the phone to ring, her pitch grows more desperate by the minute." },
];

export const STILLS = [
  { src: "/assets/stills/still_1.jpg", alt: "Traffic stop scene from a Laugh at L.A. sketch" },
  { src: "/assets/stills/still_2.jpg", alt: "Production still from Laugh at L.A." },
  { src: "/assets/stills/still_3.jpg", alt: "Stand-up comic on stage at the Laugh at L.A. taping" },
  { src: "/assets/stills/still_11.jpg", alt: "Live audience at the Laugh at L.A. taping" },
  { src: "/assets/stills/still_28.jpg", alt: "Sketch scene from Laugh at L.A." },
  { src: "/assets/stills/still_29.jpg", alt: "Office scene from a Laugh at L.A. sketch" },
];

export const EXPANSION_CITIES = [
  { city: "New York", note: "The essence of NYC comedy and culture" },
  { city: "Chicago", note: "A rich comedic history and improv style" },
  { city: "Atlanta", note: "Southern humor and emerging voices" },
  { city: "Miami", note: "Diverse cultural humor, Latin comedy front and center" },
  { city: "Dallas", note: "Texas charm and regional humor" },
  { city: "San Francisco", note: "Cutting-edge, alternative comedy" },
  { city: "Las Vegas", note: "Glamour and outrageousness on stage" },
];
